import isEmpty from 'lodash/isEmpty';

import { useEffect, useState } from 'react';

const useFilterForCheckbox = ( setStart, dataStr, scrollToTop, initialCode = '' ) => {
  const [ code ] = useState( initialCode );
  const codes = code?.split( ',' ).sort();
  const formattedInitialObj = codes?.toString();
  const initialObj = formattedInitialObj !== '' ? { [formattedInitialObj]: true } : {};
  const [ checked, setChecked ] = useState( initialObj );

  const handleFilter = ( e ) => {
    setStart( 0 );
    setChecked( ( cur ) => {
      const copy = { ...cur };
      if ( formattedInitialObj !== '' ) {
        copy[formattedInitialObj] = !e.target.checked;
      }
      copy[e.target.value] = e.target.checked;
      return copy;
    });
    scrollToTop();
  };

  const allUnchecked = !isEmpty( checked ) ? Object.values( checked ).every( ( value ) => value === false ) : null;

  if ( allUnchecked ) {
    setChecked({});
  }

  const processFormatKeys = ( key ) => key.substr( 0, key.lastIndexOf( '-' ) ).slice( -2 );
  const returnCheckedItem = ( key, value ) => value === true && key.includes( '-' ) ? processFormatKeys( key ) : value === true && !key.includes( '-' ) ? key : '';

  useEffect( () => {
    const arrayOfKeys = () => !isEmpty( checked ) ? Object?.entries( checked ).map( ( [ key, value ] ) => returnCheckedItem( key, value ) ) : [];
    const arr = arrayOfKeys();
    const filter = arr.filter( ( item ) => item !== null );
    document.querySelector( '.list--inner .inner-blocks-wrapper' ).setAttribute( dataStr, filter.length > 0 ? filter : '' );
  }, [ checked ] );

  return {
    checked,
    setChecked,
    handleFilter,
    initialObj
  };
};

export default useFilterForCheckbox;
